<template>
    <div>
        <admin-header>
            <template #header>
                <admin-breadcrumbs :crumbs="crumbs"></admin-breadcrumbs>
            </template>
        </admin-header>

        <div class="lg:grid lg:gap-4 lg:grid-cols-12 lg:m-4">
            <div class="flex flex-col space-y-4 lg:col-span-8 lg:px-0">
                <div class="grid gap-y-3 grid-cols-1 sm:gap-x-2 sm:gap-y-2 sm:grid-cols-2 lg:grid-cols-3">
                    <div v-for="(competitor, i) in competitors" @mouseenter="$refs.timelapse[i].play()" @mouseleave="$refs.timelapse[i].pause()" class="relative flex flex-col shadow overflow-hidden lg:border-0 lg:border-gray-300 lg:rounded-lg lg:shadow-none">
                        <div v-if="competitor.verificationPhotoUrl" class="absolute z-10 left-3 top-3 w-20 h-20 rounded-full shadow-md overflow-hidden ring-2 ring-white">
                            <img :src="competitor.verificationPhotoUrl" alt="Verification Photo" class="w-full h-full object-cover object-center" />
                        </div>

                        <div class="aspect-w-9 aspect-h-16 bg-gray-200">
                            <video ref="timelapse" :src="competitor.video.timelapseUrl" preload="auto" loop muted class="w-full h-full object-cover object-center"></video>
                        </div>

                        <div class="-mt-16 px-2 py-2">
                            <link-button :href="route('admin.participant', { post: post, competitor: competitor.id })" class="relative z-10 w-full shadow-md sm:ring-0 sm:ring-offset-0">Review</link-button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Aside -->
            <div class="hidden lg:block lg:col-span-4">
                <div class="sticky top-8 space-y-4">
                    <div class="px-4 py-6 bg-white rounded-lg shadow">
                        <div class="block hover:opacity-75 space-y-4">
                            <div class="flex flex-col justify-center align-middle text-center">
                                <div class="flex justify-center mb-1 mr-1 text-pink-500 text-6xl font-bold">
                                    <span class="currency font-display">{{ post.pledgedAmount | abbr }}</span>
                                </div>
                                <div class="text-pink-300 text-xs font-semibold uppercase">value of tokens pledged</div>
                            </div>

                            <!-- Supporter Stats -->
                            <div class="grid gap-1 grid-cols-3 text-center">
                                <div class="col-span-1">
                                    {{ post.pledgesCount | abbr }}
                                    <div class="text-gray-500 text-xs uppercase">
                                        {{ "pledge" | pluralize(post.pledgesCount) }}
                                    </div>
                                </div>
                                <div class="col-span-1">
                                    {{ post.likesCount | abbr }}
                                    <div class="text-gray-500 text-xs uppercase">{{ "like" | pluralize(post.likesCount) }}</div>
                                </div>
                                <div class="col-span-1">
                                    {{ post.favoritersCount | abbr }}
                                    <div class="text-gray-500 text-xs uppercase">
                                        {{ "follower" | pluralize(post.favoritersCount) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Link :href="post.showUrl" class="group block bg-white rounded-lg shadow space-y-4">
                        <!-- Featured Image -->
                        <div class="aspect-w-10 aspect-h-7 block p-0 w-full h-48 shadow-inner group-hover:opacity-75 sm:rounded-t-lg sm:overflow-hidden" v-html="post.featuredImageHtml"></div>

                        <!-- Post Details -->
                        <div class="pb-3 px-4">
                            <div class="line-clamp-3 group-hover:text-gray-500 text-gray-700 text-sm" v-html="post.html"></div>

                            <button class="flex items-center pt-3 group-hover:text-blue-500 text-gray-500 text-sm">
                                <svg class="-ml-1 mr-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15 19l-7-7 7-7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                </svg>
                                <span>Go to challenge</span>
                            </button>
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout"
import AdminHeader from "@/Components/Admin/AdminHeader"
import Tooltip from "@/Components/Tooltip"
import AdminBreadcrumbs from "@/Components/Admin/Breadcrumbs"
import LinkButton from "@/Components/Buttons/LinkButton"

export default {
    components: { AdminBreadcrumbs, Tooltip, AdminHeader, LinkButton },
    layout: AdminLayout,

    props: {
        post: {
            required: true,
            type: Object,
        },
    },

    computed: {
        competitors() {
            return this.post.pendingCompetitors
        },
        crumbs() {
            return [
                {
                    text: "Challenges",
                    href: this.route("admin.posts"),
                },
                {
                    text: this.post.text,
                    href: this.route("admin.post", { post: this.post }),
                },
            ]
        },
        videoPlayerOptions() {
            return { sources: [{ src: this.post.streamUrl }], fluid: true, autoplay: true }
        },
    },
}
</script>
